import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const initialState = {
	userList: [],
	chatMessages: [],
	chatUser: null,
	roomId: null,
	isTypingRooms: [],
	chatListKeyword: '',
	newMessageAlert: false,
	receiverDetails: [],
	refetchChatDetailsQuery: () => {},
};

const chatStore = (set: any) => ({
	...initialState,
	setUserList: (data: any) => set((state: any) => ({ ...state, userList: data })),
	setChatMessages: (data: any) => set((state: any) => ({ ...state, chatMessages: data })),
	setChatUser: (data: any) => set((state: any) => ({ ...state, chatUser: data })),
	setRoomId: (data: number | null) => set((state: any) => ({ ...state, roomId: data })),
	setIsTypingRooms: (roomId: number) =>
		set((state: any) => {
			if (!state.isTypingRooms.includes(Number(roomId))) {
				return { ...state, isTypingRooms: [...state.isTypingRooms, Number(roomId)] };
			}
			return state;
		}),
	removeIsTypingRoom: (roomId: number) =>
		set((state: any) => ({
			...state,
			isTypingRooms: state.isTypingRooms.filter((id: number) => id !== Number(roomId)),
		})),
	setChatListKeyword: (data: string) =>
		set((state: any) => ({ ...state, chatListKeyword: data || '' })),
	setNewMessageAlert: (data: boolean) => set((state: any) => ({ ...state, newMessageAlert: data })),
	setReceiverDetails: (data: any) => set((state: any) => ({ ...state, receiverDetails: data })),
	setRefetchChatDetailsQuery: (data: any) =>
		set((state: any) => ({ ...state, refetchChatDetailsQuery: data })),
	resetState: () => set({ ...initialState }),
});

const useChatStore = create(devtools(chatStore));

export const {
	setUserList,
	setChatMessages,
	setChatUser,
	setRoomId,
	setIsTypingRooms,
	setChatListKeyword,
	setNewMessageAlert,
	setReceiverDetails,
	setRefetchChatDetailsQuery,
	resetState,
} = useChatStore.getState();

export default useChatStore;
